const addPropsToDirsAndFiles = (response, siteName, setData, siteId) => {
    const currentDirUrl = response.data.data.current_directory;
    
		let dirs = response.data.data.dirs.map((dir) => {
			const value = JSON.stringify({
        name: dir.name,
        size: dir.size,
        modify: dir.modify,
        siteName: siteName,
        siteId: siteId,
        isFolder: true,
        directory: currentDirUrl
			})
			return {
				value: value,
				label: dir.name,
				showCheckbox: false,
				children: [ { value: 'waiting server response...', label: 'waiting server response...', showCheckbox: false } ]
			};
		});

		if (response.data.data.dirs.length === 0) {
			dirs = [ { value: '', label: '..', showCheckbox: false } ];
		}

		const files = response.data.data.files.map((file) => {
			const value = JSON.stringify({
        name: file.name,
        size: file.size,
        modify: file.modify,
				siteName: siteName,
				siteId: siteId,
				isFolder: false,
				directory: response.data.data.current_directory
			})
			return {
				value: value,
				label: file.name,
				showCheckbox: false
			};
		});

    setData(dirs.concat(files));
    
    return {
      dirs: dirs
    }
};

export default addPropsToDirsAndFiles;
